const assetModelsReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default assetModelsReducer;